// @react
import React, { useState } from 'react'
import { Router } from 'react-router-dom'
// @design
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core'
import atdTheme from '@bit/atd.web.theme'
// @common
import whyDidYouRender from '@welldone-software/why-did-you-render'
import history from './utils/history'
// @components
import HeaderWrap from 'modules/common/components/HeaderWrap'
import headerData from '__TO_REPLACE_WITH_REAL_DATA/header'
import SnackbarProvider from 'modules/common/components/SnackbarProvider'
// @graphql
import { disableFragmentWarnings } from '@apollo/client/core'
import { ApolloProvider } from '@apollo/client'
import client from './graphql/Apollo/apolloClient'
import { HeaderSearchContext } from 'modules/common/context/headerSearch'
import catchError from './modules/common/HOC/catchError'

if (process.env.NODE_ENV === 'development') {
  whyDidYouRender(React)
}
disableFragmentWarnings()

const App = (): React.ReactElement => {
  const [isShowSearch, setIsShowSearch] = useState(false)
  const [isAuth, setIsAuth] = useState<boolean | undefined>(undefined)

  return (
    <>
      <Router history={history}>
        <ApolloProvider client={client}>
          <MuiThemeProvider theme={atdTheme}>
            <CssBaseline />
            <SnackbarProvider>
              <HeaderSearchContext.Provider
                value={{ isShowSearch, setIsShowSearch }}
              >
                {
                  <HeaderWrap
                    data={headerData}
                    isShowSearch={isShowSearch}
                    setIsShowSearch={setIsShowSearch}
                    setIsAuth={setIsAuth}
                  />
                }
              </HeaderSearchContext.Provider>
            </SnackbarProvider>
          </MuiThemeProvider>
        </ApolloProvider>
      </Router>
    </>
  )
}

export default catchError(App)
